import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "actions", "onHandleMouseDown", "onDropdownOpenChange", "responsiveSize", "connectDragSource", "isSelectedItem"];
import { memoize } from 'underscore';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TrellisVerticalEdgeToolbar as VerticalEdgeToolbar } from 'layout-dnd-components/DndToolbar/VerticalEdgeToolbar';
// @ts-expect-error not typed
import { updateSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { cloneRowFromLayoutSection, requestCloneFromLayoutSection, deleteRowFromLayoutSection
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/moduleActions';
import { ROW } from 'ContentEditorUI/constants/cloneTypes';
// @ts-expect-error not typed
import { logLayoutSectionEvent } from 'InpageEditorUI/eventsAsActions/layoutTransitionEventsAsActions';
// @ts-expect-error not typed
import { LAYOUT_SECTION_TRACKING } from 'ContentEditorUI/lib/layoutSection/constants';
// @ts-expect-error not typed
import { startGeneratedHublRequest } from 'ContentEditorUI/redux/actions/hublActions';
import { hashFunctionForObject } from './helpers';
import { useSelector } from 'react-redux';
import { getIsTrellisTheme } from '../../redux/selectors/layoutSectionDndSelectors';
import { CustomHublIcon } from 'foundations-assets/icons/components/CustomHublIcon';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { DuplicateIcon } from 'foundations-assets/icons/components/DuplicateIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { HideIcon } from 'foundations-assets/icons/components/HideIcon';
import { RowIcon } from 'foundations-assets/icons/components/RowIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const buildStyleRowAction = (rowName, layoutSectionId, dispatch, bus, {
  onlyInDropdown
} = {}) => ({
  id: 'row-styles',
  icon: EditIcon,
  menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.row.editStyles"
  }),
  tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.row.editStyles"
  }),
  onlyInDropdown,
  callback: () => {
    dispatch(updateSelectedItem(rowName, {
      containerId: layoutSectionId
    }));
    bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.EDIT_LAYOUT_STYLES, {
      type: 'ROW'
    }));
  },
  placement: 'right'
});
export const buildDuplicateRowAction = (rowName, layoutSectionId, dispatch, bus, {
  onlyInDropdown
} = {}) => ({
  id: 'row-duplicate',
  icon: DuplicateIcon,
  menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.row.clone"
  }),
  tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.row.clone"
  }),
  onlyInDropdown,
  callback: () => {
    bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.CLONE_ROW));
    dispatch(requestCloneFromLayoutSection(rowName, layoutSectionId, ROW, cloneRowFromLayoutSection(rowName, layoutSectionId)));
  },
  placement: 'right'
});
export const buildDeleteRowAction = (rowName, layoutSectionId, dispatch, bus, {
  onlyInDropdown
} = {}) => ({
  id: 'row-delete',
  icon: DeleteIcon,
  menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.row.delete"
  }),
  tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.row.delete"
  }),
  onlyInDropdown,
  callback: () => {
    bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.DELETE_ROW));
    dispatch(deleteRowFromLayoutSection(rowName, layoutSectionId));
  },
  placement: 'right'
});
const buildCopyAsHublAction = (rowName, layoutSectionId, dispatch) => ({
  id: 'copy-as-hubl',
  icon: CustomHublIcon,
  menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.copy"
  }),
  menuTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.copy"
  }),
  onlyInDropdown: true,
  callback: () => {
    dispatch(startGeneratedHublRequest(rowName, layoutSectionId));
  }
});
const buildHideOnMobileAction = (bus, toggleNodeVisibilityOnThisBreakpoint) => ({
  id: 'row-hide',
  icon: HideIcon,
  menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.row.hide"
  }),
  tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.row.hide"
  }),
  callback: e => {
    bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.HIDE_ROW));
    if (e) {
      toggleNodeVisibilityOnThisBreakpoint(false, e);
    }
  },
  onlyInDropdown: false
});
export const buildActionsForRow = memoize(({
  rowName,
  layoutSectionId,
  isInDefaultBreakpointMode,
  dispatch,
  bus,
  isInDeveloperMode,
  toggleNodeVisibilityOnThisBreakpoint,
  canToggleRowVisibility
}) => {
  const actions = [buildStyleRowAction(rowName, layoutSectionId, dispatch, bus, {
    onlyInDropdown: false
  })];
  if (isInDefaultBreakpointMode) {
    actions.push(buildDuplicateRowAction(rowName, layoutSectionId, dispatch, bus, {
      onlyInDropdown: false
    }), buildDeleteRowAction(rowName, layoutSectionId, dispatch, bus, {
      onlyInDropdown: false
    }));
    if (isInDeveloperMode) {
      actions.push(buildCopyAsHublAction(rowName, layoutSectionId, dispatch));
    }
  } else {
    // if row is not in the sidebar, there is no way to unhide it, so we don't want to include the button
    if (canToggleRowVisibility) {
      actions.push(buildHideOnMobileAction(bus, toggleNodeVisibilityOnThisBreakpoint));
    }
  }
  return actions;
}, hashFunctionForObject);
export const BaseResponsiveRowToolbar = _ref => {
  let {
      active,
      actions,
      onHandleMouseDown,
      onDropdownOpenChange,
      responsiveSize,
      connectDragSource,
      isSelectedItem
    } = _ref,
    toolbarProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isTrellisTheme = useSelector(getIsTrellisTheme);
  const buttonActions = [...actions];
  const styleActionIndex = buttonActions.findIndex(action => action.id === 'row-styles');
  const styleActionCallback = buttonActions[styleActionIndex] ? buttonActions[styleActionIndex].callback : () => {};

  // Assume style action button's callback should be used when clicking on the "icon" of this toolbar
  const iconClickHandler = styleActionIndex === -1 || buttonActions[styleActionIndex].disabled ? undefined : styleActionCallback;
  if (isSelectedItem && styleActionIndex !== -1) {
    buttonActions.splice(styleActionIndex, 1);
  }
  return /*#__PURE__*/_jsx(VerticalEdgeToolbar, Object.assign({}, toolbarProps, {
    "data-test-id": "hs-ls-responsive-row-toolbar",
    position: "absolute",
    zIndex: 4,
    variant: "primary",
    active: active,
    icon: RowIcon,
    actions: buttonActions,
    responsiveSize: responsiveSize,
    onHandleMouseDown: onHandleMouseDown,
    onDropdownOpenChange: onDropdownOpenChange,
    onHandleClick: iconClickHandler,
    handleTooltipPlacement: "right",
    handleButtonRef: handleButtonElement => {
      if (handleButtonElement && connectDragSource) {
        connectDragSource(handleButtonElement);
      }
    },
    handleButtonStyles: {
      cursor: 'move',
      borderWidth: '100'
    },
    handleTooltip: I18n.text('inpage.actionToolbar.row.label'),
    draggable: true,
    isTrellisTheme: isTrellisTheme
  }));
};